import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { CameraPhotoComponent } from './components/camera-photo/camera-photo.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    GeneralModule,
  ],
  declarations: [
    CameraPhotoComponent,
  ],
  exports: [
    CameraPhotoComponent,
  ],
  providers: [

  ]
})
export class CameraModule { }
